import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		action: PropTypes.string,
		activity: PropTypes.string,
		resource: PropTypes.object
	};

    getActivity = () => {
		if( this.props.activity ) return this.props.activity;
		return this.props.resource && 'post_type' in this.props.resource ? this.props.resource.post_type.singular_lower : ''
	};

    render() {

		return (

			<span>{this.props.action} {this.getActivity()}</span>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/components/Text.js